"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

require("./activity.scss");

var _SecureImage = _interopRequireDefault(require("../../components/image/SecureImage"));

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function (nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

class ActivityPreview extends _react.Component {
  render() {
    var _a, _b;

    const {
      backgroundType,
      background,
      previewImage,
      creative,
      editable
    } = this.props;

    if (background && backgroundType === 'image' && (previewImage.length > 0 || background.filename && background.filename.length > 0)) {
      return /*#__PURE__*/_react.default.createElement("div", {
        className: "activity-preview-container"
      }, /*#__PURE__*/_react.default.createElement("div", {
        className: "activity-preview"
      }, /*#__PURE__*/_react.default.createElement("div", {
        className: "activity-preview-screen"
      }, /*#__PURE__*/_react.default.createElement("div", {
        className: "activity-preview-image",
        style: creative || editable ? {
          backgroundImage: `url(${previewImage})`
        } : {}
      }, !creative && !editable && /*#__PURE__*/_react.default.createElement(_SecureImage.default, {
        url: background.filename,
        alt: "Activity background image."
      })))));
    }

    if (backgroundType === 'gradient' && background && background.gradient) {
      return /*#__PURE__*/_react.default.createElement("div", {
        className: "activity-preview-container"
      }, /*#__PURE__*/_react.default.createElement("div", {
        className: "activity-preview"
      }, /*#__PURE__*/_react.default.createElement("div", {
        style: {
          background: `linear-gradient(#${(_a = background.gradient) === null || _a === void 0 ? void 0 : _a.start}, #${(_b = background.gradient) === null || _b === void 0 ? void 0 : _b.end})`
        },
        className: "activity-preview-screen"
      })));
    }

    return /*#__PURE__*/_react.default.createElement("div", {
      className: "activity-preview-container"
    }, /*#__PURE__*/_react.default.createElement("div", {
      className: "activity-preview"
    }, /*#__PURE__*/_react.default.createElement("div", {
      className: "activity-preview-screen"
    }, /*#__PURE__*/_react.default.createElement("span", null, "Content will appear once you complete the Background step."))));
  }

}

var _default = ActivityPreview;
exports.default = _default;